module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (10).c0b180cb.jpg";